import {
  LOADER_STATUS,
  PROFILE_DATA,
  SELECTED_ENTITY,
  SELECTED_GSTINS,
  SET_ENTITY_LIST,
  STORE_PERIOD,
  TABLE_DATA,
  TOTAL_REOCRDS,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  selectedEntity: "",
  profileData: [],
  selectedGstin: [],
  entityMasterList: [],
  startDate: null,
  endDate: null,
  selectedPeriodSingle: null,
  isChecked: true,
  total_count: 0,
  tableData: [],
};

const ewbRecoFetchReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SET_ENTITY_LIST:
      return {
        ...state,
        entityMasterList: action.payload,
      };
    case PROFILE_DATA:
      return {
        ...state,
        profileData: action.profileData,
      };
    case TOTAL_REOCRDS:
      return {
        ...state,
        total_count: action.data,
      };
    case SELECTED_GSTINS:
      return {
        ...state,
        selectedGstin: action.selectedGstin,
      };
    case SELECTED_ENTITY:
      return {
        ...state,
        selectedEntity: action.data,
      };
    case STORE_PERIOD:
      return {
        ...state,
        startDate: action.date.startDate,
        endDate: action.date.endDate,
      };
    case TABLE_DATA:
      return {
        ...state,
        tableData: action.tableData,
      };
    default:
      return state;
  }
};

export default ewbRecoFetchReducer;
